export enum FrequentlyAskedQuestionsFilterOption {
  ProductCode = 'faqsFilter.ProductCode',
  ProductSku = 'faqsFilter.ProductSku',
  Top = 'faqsFilter.Top',
}
